/** Created by azhou on 2018/11/30.*/
<template>
  <div id="china-map"></div>
</template>

<script>
  import '../../../../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据

  // 引入 ECharts 主模块
  const echarts = require('echarts/lib/echarts')
  // 引入地图
  require('echarts/lib/chart/scatter')
  require('echarts/lib/chart/effectScatter')
  require('echarts/lib/chart/custom')
  // 引入提示框和标题组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')

  export default {
    props: {
      colorArr: {
        type: Array,
        default () {
          return ['#1e00ff', '#011ad5', '#4730f4', '#406be4', '#007eff', '#00baff', '#00f0ff', '#acfeff']
        }
      },
      dataSet: {
        type: Array,
        default () {
          return []
        }
      },
      showVisualMap: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      dataSet () {
        this.initEchart()
      }
    },
    mounted() {
      //监控窗口大小变化，重新渲染组件大小
      window.onresize = this.$GFUN.damControl(() => {
        this._myChart.resize();
      }, 200)
    },
    methods: {
      /*初始化echart图表*/
      initEchart () {
        // 基于准备好的dom，初始化echarts实例
        this._myChart = echarts.init($('#china-map').get(0))
        //获取色值映射区间的最大最小值
        let mapMin = Math.min.apply(Math, this.dataSet.map(item => {
            return item.value
          })),
          mapMax = Math.max.apply(Math, this.dataSet.map(item => {
            return item.value
          }))
        let option = {
          /*title : { text: '用户注册全国分布图', left: 'center',textStyle:{color:'#919191'} },*/
          tooltip: { trigger: 'item' },
          visualMap: {
            min: mapMin,
            max: mapMax,
            show: this.showVisualMap,
            type: 'piecewise',
            left: '50px',
            textStyle: { color: '#eee' },
            pieces: [
              { value: 0 },
              { min: 1, max: 10 },
              { min: 11, max: 50 },
              { min: 51, max: 100 },
              { min: 101, max: 400 },
              { min: 401, max: 1000 },
              { min: 1001, max: 2000 },
              { min: 2000 },
            ],
            color: this.colorArr,
            /*calculable : true,
            inRange: {
              color: this.colorArr,
            }*/
          },
          series: [
            {
              name: '认证数',
              type: 'map',
              mapType: 'china',
              roam: false,
              left: '50px',
              right: '50px',
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              data: this.dataSet
            },
          ]
        }
        // 绘制图表
        this._myChart.setOption(option)
      }
    }
  }
</script>
